import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MaterialModule } from 'src/app/material.module';
import { CerereTypeComponent } from './cerere-type.component';
import { AddCerereTypeComponent } from './add-cerere-type/add-cerere-type.component';
import { EditCerereTypeComponent } from './edit-cerere-type/edit-cerere-type.component';

@NgModule({
    declarations: [
        CerereTypeComponent,
        AddCerereTypeComponent,
        EditCerereTypeComponent,
    ],
    imports: [CommonModule, ReactiveFormsModule, FormsModule, MaterialModule],
    exports: [
        CerereTypeComponent,
        AddCerereTypeComponent,
        EditCerereTypeComponent,
    ],
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class RequestTypesModule { }
